module.exports = __webpack_public_path__ + "media/images/official/top_mv3_pc-18d33f2f961daba642576063d7268ee4.jpg";